<!--
 * @Description: 
 * @Author: -898-
 * @Date: 2024-04-23 09:02:35
 * @LastEditTime: 2024-04-23 14:07:14
 * @LastEditors: -898-
-->

<template>
  <section class="app-main">
    <ct-head />
    <div class="content-box">
      <router-view />
    </div>
    <back-top> </back-top>
    <ct-foot/>
  </section>
</template>

<script>
import CtHead from './components/head.vue'
import CtFoot from './components/foot.vue'
import BackTop from '@/components/backTop.vue'
export default {
  name: 'AppMain',
  components: {
    CtHead,
    CtFoot,
    BackTop
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  height: 100%;
  width: 100%;
  position: relative;
  background-color: #fff;
  min-width: 1366px;
  .content-box {
    min-height: calc(100vh - 258px);
  }
}
</style>
